import { HttpContextToken } from '@angular/common/http';

/**
 * Marks a request as already addressed to its correct service, so `apiRoutingInterceptor`
 * leaves it alone.
 *
 * Requests issued through a `TargetApiClient` have chosen their target explicitly. Without
 * this marker the interceptor would resolve the path against the generated route table and
 * rewrite the host — meaning the table silently wins wherever it disagrees with the client.
 *
 * Retire this together with `../api-routing/` once no callers build URLs from `adminApiUrl`.
 */
export const BYPASS_API_ROUTING = new HttpContextToken<boolean>(() => false);
